module.exports = __webpack_public_path__ + "media/day/176-69640974.svg";